import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import { Alert, Button, ButtonContainer, Checkbox, FormControlLabel, Grid, Link, MenuItem, Modal, Select, TextField, Typography } from '@emburse/embark-core';
import { debounce } from 'lodash';
import VerticallyCenteredLayout from '../../components/Layouts/VerticallyCenteredLayout';
import { AuthCard, InputPassword } from '../../components';
import { defaultValidation, validateEmail, validateConfirmEmail, validatePassword, validateConfirmPassword, validatePhone } from '../../util/formValidation';
import { ratePassword } from '../../util/ratePassword';
const databaseRegions = [
    {
        label: 'North America',
        value: '1'
    },
    {
        label: 'Europe',
        value: '2'
    }
];
export default function FreeTrial({ Validation, ErrorMessage, FirstName, LastName, Email, ConfirmEmail, Phone, DatabaseRegion, CompanyName }) {
    const [modalOpen, setModalOpen] = useState(false);
    // Form Fields
    const [firstName, setFirstName] = useState({
        value: FirstName,
        valid: true,
        validationText: ''
    });
    const [lastName, setLastName] = useState({
        value: LastName,
        valid: true,
        validationText: ''
    });
    const [email, setEmail] = useState({
        value: Email,
        valid: true,
        validationText: ''
    });
    const [confirmEmail, setConfirmEmail] = useState({
        value: ConfirmEmail,
        valid: true,
        validationText: ''
    });
    const [password, setPassword] = useState({
        value: '',
        valid: true,
        validationText: ''
    });
    const [confirmPassword, setConfirmPassword] = useState({
        value: '',
        valid: true,
        validationText: ''
    });
    const [phone, setPhone] = useState({
        value: Phone,
        valid: true,
        validationText: ''
    });
    const [companyName, setCompanyName] = useState({
        value: CompanyName,
        valid: true,
        validationText: ''
    });
    const [databaseRegion, setDatabaseRegion] = useState({
        value: DatabaseRegion === 'Europe' ? '2' : '1',
        valid: true,
        validationText: ''
    });
    const [gdprOptIn, setGdprOpIn] = useState(false);
    useEffect(() => {
        if (Validation.length) {
            const stateHandlerMap = {
                Company: setCompanyName,
                Phone: setPhone,
                Email: setEmail,
                'Confirm Email': setConfirmEmail,
                Password: setPassword,
                'Confirm Password': setConfirmPassword,
                'First Name': setFirstName,
                'Last Name': setLastName
            };
            Validation.forEach((item) => {
                if (item.Key) {
                    stateHandlerMap[item.Key]((prevState) => ({
                        ...prevState,
                        validationText: item.Message,
                        valid: false
                    }));
                }
            });
        }
    }, [Validation]);
    //* **** Event Handlers ******/
    const firstNameChangeHandler = debounce((e) => {
        setFirstName({
            validationText: defaultValidation(e.target.value),
            valid: e.target.value.length > 0,
            value: e.target.value
        });
    }, 50);
    const lastNameChangeHandler = debounce((e) => {
        setLastName({
            validationText: defaultValidation(e.target.value),
            valid: e.target.value.length > 0,
            value: e.target.value
        });
    }, 50);
    const emailChangeHandler = debounce((e) => {
        setEmail({
            validationText: validateEmail(e.target.value),
            valid: validateEmail(e.target.value).length === 0,
            value: e.target.value
        });
        if (confirmEmail.value.length > 0) {
            setConfirmEmail({
                ...confirmEmail,
                validationText: validateConfirmEmail(confirmEmail.value, e.target.value),
                valid: validateConfirmEmail(confirmEmail.value, e.target.value).length === 0
            });
        }
    }, 300);
    const confirmEmailChangeHandler = debounce((e) => {
        setConfirmEmail({
            validationText: validateConfirmEmail(e.target.value, email.value),
            valid: validateConfirmEmail(e.target.value, email.value).length === 0,
            value: e.target.value
        });
    }, 300);
    const passwordChangeHandler = debounce((e) => {
        setPassword({
            validationText: validatePassword(e.target.value),
            valid: validatePassword(e.target.value).length === 0,
            value: e.target.value
        });
    }, 300);
    const confirmPasswordChangeHandler = debounce((e) => {
        setConfirmPassword({
            validationText: validateConfirmPassword(e.target.value, password.value),
            valid: validateConfirmPassword(e.target.value, password.value).length === 0,
            value: e.target.value
        });
    }, 300);
    const phoneChangeHandler = debounce((e) => {
        setPhone({
            validationText: validatePhone(e.target.value),
            valid: validatePhone(e.target.value).length === 0,
            value: e.target.value
        });
    }, 300);
    const companyNameChangeHandler = debounce((e) => {
        setCompanyName({
            validationText: defaultValidation(e.target.value),
            valid: e.target.value.length > 0,
            value: e.target.value
        });
    }, 50);
    const databaseRegionChangeHandler = (e) => setDatabaseRegion({
        validationText: defaultValidation(e.target.value),
        valid: e.target.value.length > 0,
        value: e.target.value
    });
    const gdprOptInChangeHandler = (e, value) => setGdprOpIn(value);
    const modalCloseHandler = () => setModalOpen(false);
    const dataBaseConfirmHandler = () => {
        const submitInputId = 'FreeTrial_submit';
        const submitButton = document.getElementById(submitInputId);
        submitButton.click();
    };
    const onSubmitValidation = () => {
        let valid = true;
        if (firstName.value.length === 0 || !firstName.valid) {
            setFirstName((prevState) => ({
                ...prevState,
                valid: false,
                validationText: defaultValidation(prevState.value)
            }));
            valid = false;
        }
        if (lastName.value.length === 0 || !lastName.valid) {
            setLastName((prevState) => ({
                ...prevState,
                valid: false,
                validationText: defaultValidation(prevState.value)
            }));
            valid = false;
        }
        if (email.value.length === 0 || !email.valid) {
            setEmail((prevState) => ({
                ...prevState,
                valid: false,
                validationText: validateEmail(prevState.value)
            }));
            valid = false;
        }
        if (confirmEmail.value.length === 0 ||
            !confirmEmail.valid ||
            validateConfirmEmail(confirmEmail.value, email.value).length !== 0) {
            setConfirmEmail((prevState) => ({
                ...prevState,
                valid: false,
                validationText: validateConfirmEmail(prevState.value, email.value)
            }));
            valid = false;
        }
        if (password.value.length === 0 || !password.valid) {
            setPassword((prevState) => ({
                ...prevState,
                valid: false,
                validationText: validatePassword(prevState.value)
            }));
            valid = false;
        }
        if (confirmPassword.value.length === 0 ||
            !confirmPassword.valid ||
            validateConfirmPassword(confirmPassword.value, password.value).length !== 0) {
            setConfirmPassword((prevState) => ({
                ...prevState,
                valid: false,
                validationText: validateConfirmPassword(prevState.value, password.value)
            }));
            valid = false;
        }
        if (phone.value.length === 0 || !phone.valid) {
            setPhone((prevState) => ({
                ...prevState,
                valid: false,
                validationText: validatePhone(prevState.value)
            }));
            valid = false;
        }
        if (companyName.value.length === 0 || !companyName.valid) {
            setCompanyName((prevState) => ({
                ...prevState,
                valid: false,
                validationText: defaultValidation(prevState.value)
            }));
            valid = false;
        }
        if (databaseRegion.value.length === 0 || !databaseRegion.valid) {
            setDatabaseRegion((prevState) => ({
                ...prevState,
                valid: false,
                validationText: defaultValidation(prevState.value)
            }));
            valid = false;
        }
        return valid;
    };
    const onSubmitHandler = () => {
        // Validate Form
        const isValid = onSubmitValidation();
        if (isValid) {
            setModalOpen(true);
        }
    };
    return (_jsx(VerticallyCenteredLayout, { children: _jsxs(AuthCard, { id: "FreeTrial", titleVariant: "h4", titleText: "Get Certify risk-free for 14 days", buttonLabel: "Start My Trial", buttonValue: "StartMyTrial", onSubmit: onSubmitHandler, disabled: !gdprOptIn, children: [_jsxs(Grid, { container: true, spacing: 3, direction: "column", justifyContent: "center", alignItems: "stretch", children: [_jsx(Grid, { item: true, style: { marginTop: '-24px' }, children: _jsx(Typography, { variant: "h6", align: "center", children: "Discover why over 5,000 companies from 80 countries trust us to automate their expense management and increase employee happiness." }) }), _jsx(Grid, { item: true, children: _jsx(Typography, { variant: "body1", align: "center", children: "Sign up below to start your risk-free trial." }) }), ErrorMessage.length > 0 && (_jsx(Grid, { item: true, children: _jsx(Alert, { severity: "error", children: _jsx("span", { id: "ErrorMessage", children: ErrorMessage }) }) })), _jsx(Grid, { item: true, style: { marginTop: '24px' }, children: _jsx(Typography, { variant: "body1", children: _jsx("strong", { children: "Personal Information" }) }) }), _jsx(Grid, { item: true, children: _jsx(TextField, { id: "CER_FirstName", name: "CER_FirstName", fullWidth: true, label: "First Name", type: "text", defaultValue: firstName.value, helperText: firstName.validationText, error: !firstName.valid, onChange: firstNameChangeHandler }) }), _jsx(Grid, { item: true, children: _jsx(TextField, { id: "CER_LastName", name: "CER_LastName", fullWidth: true, label: "Last Name", type: "text", defaultValue: lastName.value, helperText: lastName.validationText, error: !lastName.valid, onChange: lastNameChangeHandler }) }), _jsx(Grid, { item: true, children: _jsx(TextField, { id: "CER_Email", name: "CER_Email", fullWidth: true, label: "Email Address", type: "email", defaultValue: email.value, helperText: email.validationText, error: !email.valid, onChange: emailChangeHandler }) }), _jsx(Grid, { item: true, children: _jsx(TextField, { id: "CER_ConfirmEmail", name: "CER_ConfirmEmail", fullWidth: true, label: "Confirm Email Address", type: "email", defaultValue: confirmEmail.value, helperText: confirmEmail.validationText, error: !confirmEmail.valid, onChange: confirmEmailChangeHandler }) }), _jsxs(Grid, { item: true, children: [_jsx(InputPassword, { id: "pw_1", label: "Password", helperText: password.validationText, error: !password.valid, onChangeHandler: passwordChangeHandler }), _jsx("input", { id: "pwRating", name: "pwRating", type: "hidden", value: ratePassword(password.value) })] }), _jsx(Grid, { item: true, children: _jsx(InputPassword, { id: "pw_2", label: "Confirm Password", helperText: confirmPassword.validationText, error: !confirmPassword.valid, onChangeHandler: confirmPasswordChangeHandler }) }), _jsx(Grid, { item: true, children: _jsx(TextField, { id: "CER_Phone", name: "CER_Phone", fullWidth: true, label: "Phone", type: "text", defaultValue: phone.value, helperText: phone.validationText, error: !phone.valid, onChange: phoneChangeHandler }) }), _jsx(Grid, { item: true, style: { marginTop: '24px' }, children: _jsx(Typography, { variant: "body1", children: _jsx("strong", { children: "Company Information" }) }) }), _jsx(Grid, { item: true, children: _jsx(TextField, { id: "CER_Company", name: "CER_Company", fullWidth: true, label: "Company Name", type: "text", defaultValue: companyName.value, helperText: companyName.validationText, error: !companyName.valid, onChange: companyNameChangeHandler }) }), _jsx(Grid, { item: true, children: _jsx(Select, { id: "CER_DatabaseRegion", name: "CER_DatabaseRegion", label: "Database Region", value: databaseRegion.value, helperText: databaseRegion.validationText, error: !databaseRegion.valid, onChange: databaseRegionChangeHandler, style: { width: '100%' }, children: databaseRegions.map(({ label, value }) => (_jsx(MenuItem, { value: value, children: label }, value))) }) }), _jsx(Grid, { item: true, style: { marginTop: '24px' }, children: _jsx(FormControlLabel, { value: gdprOptIn, control: _jsx(Checkbox, { id: "gdproptincb", style: { marginTop: '-12px' }, color: "primary", onChange: gdprOptInChangeHandler }), style: { alignItems: 'flex-start' }, label: _jsxs(Typography, { variant: "body2", children: ["I agree to receive", ' ', _jsx(Link, { href: "https://www.certify.com/PrivacyPolicy.aspx", children: "communication" }), ' ', "from Certify and its affiliates, and acknowledge that I can manage my preferences at any time."] }) }) })] }), _jsxs(Modal, { open: modalOpen, modalHeader: "Database Region", onClose: modalCloseHandler, children: [_jsxs(Typography, { variant: "body1", style: { marginBottom: '24px' }, children: ["Your company's data and subsequent user data will be stored in Certify's", ' ', databaseRegion.value === '2' ? 'European' : 'North American', " datacenter.", _jsx("strong", { children: " This action cannot be undone." }), _jsx("br", {}), _jsx("br", {}), "Do you wish to continue?"] }), _jsxs(ButtonContainer, { alignButtons: "right", children: [_jsx(Button, { variant: "outlined", onClick: modalCloseHandler, children: "Cancel" }), _jsx(Button, { onClick: dataBaseConfirmHandler, children: "Confirm Selection" })] })] })] }) }));
}
